const backgroundAttachment = {
  name: "background-attachment",
  path: "/background-attachment",
  title: "Background Attachment",
  description: "Utilities for controlling how background images behave when scrolling.",
  value: {
    "background-attachment": {
      "bg-fixed": "fixed",
      "bg-local": "local",
      "bg-scroll": "scroll"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<div class="bg-fixed bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover">
  <p class="text-white p-4">Background fixed</p>
</div>
        `
      }
    },
    {
      example: {
        code: `
<div class="bg-local bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover overflow-auto">
  <p class="text-white p-4">Background local</p>
</div>
        `
      }
    },
    {
      example: {
        code: `
<div class="bg-scroll bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover">
  <p class="text-white p-4">Background scroll</p>
</div>
        `
      }
    },
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-fixed</code> to keep the background image fixed when scrolling.
      </p>
      <div>
        <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-fixed</small>
        <div class="bg-fixed rounded-lg mt-2 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover flex items-center justify-center">
          <span class="text-white p-2">Background fixed</span>
        </div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-local</code> to make the background image scroll with the element's content.
      </p>
      <div>
        <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-local</small>
        <div class="bg-local rounded-lg mt-2 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover overflow-y-auto flex items-center justify-center">
          <span class="text-white p-10 max-w-sm mx-auto">
            Because the mail never stops. It just keeps coming and coming and coming, there's never a let-up. It's relentless. Every day it piles up more and more and more. And you gotta get it out but the more you get it out the more it keeps coming in. And then the barcode reader breaks and it's Publisher's Clearing House day.
            Because the mail never stops. It just keeps coming and coming and coming, there's never a let-up. It's relentless. Every day it piles up more and more and more. And you gotta get it out but the more you get it out the more it keeps coming in. And then the barcode reader breaks and it's Publisher's Clearing House day.
          </span>
        </div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-scroll</code> to make the background image scroll along with the page.
      </p>
      <div>
        <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-scroll</small>
        <div class="bg-scroll rounded-lg mt-2 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover flex items-center justify-center overflow-y-auto text-center">
          <span class="text-white p-10 max-w-xs mx-auto">
            Because the mail never stops. It just keeps coming and coming and coming, there's never a let-up. It's relentless. Every day it piles up more and more and more. And you gotta get it out but the more you get it out the more it keeps coming in. And then the barcode reader breaks and it's Publisher's Clearing House day.
          </span>
        </div>
      </div>
      `
    }
  ]
};

export default backgroundAttachment;

<div className="bg-fixed p-10 bg-local bg-scroll bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 bg-cover"></div>